import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { CloseSvg } from './Close';

export const CloseIcon = createIcon('close', CloseSvg);
/**
 * @deprecated используйте CloseIcon
 */
export const withCloseIcon = withIcon('close', CloseSvg);
